import { ReactNode, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { Loader2 } from 'lucide-react';
import { AppLayout } from '@/components/AppLayout';

interface AuthGuardProps {
  children: ReactNode;
  withLayout?: boolean;
}

export function AuthGuard({ children, withLayout = true }: AuthGuardProps) {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!loading && !user) {
      // Store the current path so we can redirect back after login
      const returnUrl = encodeURIComponent(location.pathname + location.search);
      navigate(`/auth?returnUrl=${returnUrl}`, { replace: true });
    }
  }, [loading, user, navigate, location]);

  if (loading) {
    return (
      <div className="min-h-dvh flex items-center justify-center bg-background">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
      </div>
    );
  }

  if (!user) {
    return null;
  }

  if (withLayout) {
    return <AppLayout>{children}</AppLayout>;
  }

  return <>{children}</>;
}
